var map = {
	"./cake.svg": "0930",
	"./domain.svg": "7a33",
	"./group.svg": "1001",
	"./group_add.svg": "0e29",
	"./location_city.svg": "58cd",
	"./mood.svg": "2453",
	"./mood_bad.svg": "cf60",
	"./notifications.svg": "2fab",
	"./notifications_active.svg": "0ae4",
	"./notifications_none.svg": "2a65",
	"./notifications_off.svg": "ebc7",
	"./notifications_paused.svg": "2d52",
	"./pages.svg": "1506",
	"./party_mode.svg": "3a69",
	"./people.svg": "bbfb",
	"./people_outline.svg": "c769",
	"./person.svg": "3879",
	"./person_add.svg": "39ed",
	"./person_outline.svg": "2d93",
	"./plus_one.svg": "6578",
	"./poll.svg": "afd9",
	"./public.svg": "6dc8",
	"./school.svg": "dfe0",
	"./sentiment_dissatisfied.svg": "1ad8a",
	"./sentiment_neutral.svg": "14e7b",
	"./sentiment_satisfied.svg": "addb",
	"./sentiment_very_dissatisfied.svg": "70cd",
	"./sentiment_very_satisfied.svg": "1fdc",
	"./share.svg": "d69a",
	"./whatshot.svg": "a9aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ddc7";